import { connect } from 'react-redux';

import VerifyForm from './VerifyForm.js';

const mapStateToProps = state => {
  return {
    user: state.api.user,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getUrlParam: name => {
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
      const r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
  };
};

const ConnectedVerifyForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(VerifyForm);

export default ConnectedVerifyForm;
